import { render, staticRenderFns } from "./CatalisadoresCatalogoCardList.vue?vue&type=template&id=64b327ac&"
import script from "./CatalisadoresCatalogoCardList.vue?vue&type=script&lang=ts&"
export * from "./CatalisadoresCatalogoCardList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VHover,VIcon,VImg})
